import React from 'react';

export const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      d="M4.432 3.194L9.999 8.763 15.568 3.194 16.806 4.432 11.237 10.001 16.806 15.568 15.568 16.806 9.999 11.238 4.432 16.806 3.194 15.568 8.762 10.001 3.194 4.432z"
      opacity=".5"
    />
  </svg>
);

export const FailureIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
    <path
      fillRule="evenodd"
      d="M58 4.5c3.038 0 5.5 2.462 5.5 5.5v44c0 3.038-2.462 5.5-5.5 5.5H6C2.962 59.5.5 57.038.5 54V10C.5 6.962 2.962 4.5 6 4.5zm2.5 14h-57V54c0 1.325 1.032 2.41 2.336 2.495L6 56.5h52c1.38 0 2.5-1.12 2.5-2.5V18.5zm-32.787 8.815c1.42-2.368 4.492-3.136 6.86-1.715.703.422 1.292 1.011 1.714 1.715l9.668 16.113c1.42 2.367.653 5.439-1.715 6.86-.777.466-1.666.712-2.572.712H22.332c-2.761 0-5-2.239-5-5 0-.906.247-1.795.713-2.572zm5.316.857c-.947-.568-2.176-.26-2.744.686l-9.668 16.113c-.186.31-.285.667-.285 1.029 0 1.105.896 2 2 2h19.336c.362 0 .718-.099 1.029-.285.947-.568 1.254-1.797.686-2.744l-9.668-16.113c-.169-.281-.405-.517-.686-.686zM32 42c.828 0 1.5.672 1.5 1.5S32.828 45 32 45s-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm0-10c.828 0 1.5.672 1.5 1.5v5c0 .828-.672 1.5-1.5 1.5s-1.5-.672-1.5-1.5v-5c0-.828.672-1.5 1.5-1.5zM58 7.5H6c-1.38 0-2.5 1.12-2.5 2.5v5.5h57V10c0-1.325-1.032-2.41-2.336-2.495L58 7.5zM26.5 10c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5h-19c-.828 0-1.5-.672-1.5-1.5S6.672 10 7.5 10h19zm29 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5zm-6 0c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5-1.5-.672-1.5-1.5.672-1.5 1.5-1.5z"
      opacity=".3"
    />
  </svg>
);

export const EmptyIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
    <path
      fillRule="evenodd"
      d="M48.818 22.5c2.445 0 4.58 1.61 5.229 3.785l.082.314 5.266 14.848c.068.171.105.358.105.553v14c0 3.038-2.462 5.5-5.5 5.5H10c-3.038 0-5.5-2.462-5.5-5.5V42c0-.195.037-.382.105-.553l5.218-14.684c.55-2.382 2.6-4.1 5.012-4.252l.347-.011h33.636zM22.5 43.5h-15V56c0 1.294.984 2.36 2.244 2.487L10 58.5h44c1.38 0 2.5-1.12 2.5-2.5V43.5H41.498l.001.555-.014.354C41.274 47.27 38.885 49.5 36 49.5l-8.055-.001-.354-.014C24.73 49.274 22.5 46.885 22.5 44v-.5zm26.318-18H15.182c-1.08 0-2.03.693-2.407 1.831l-.077.271L8.123 40.5H24c.78 0 1.42.595 1.493 1.356L25.5 42v2c0 1.311 1.013 2.397 2.257 2.49l.243.01h8c1.311 0 2.397-1.013 2.49-2.257L38.5 44v-2c0-.828.672-1.5 1.5-1.5h15.878l-4.624-13.062c-.242-1.047-1.12-1.812-2.17-1.924l-.266-.014zM50.8 5.232c.637.402.868 1.204.572 1.873l-.105.196-6 9.5c-.442.7-1.369.91-2.069.467-.637-.402-.868-1.204-.572-1.873l.105-.196 6-9.5c.442-.7 1.369-.91 2.069-.467zm-37.602 0c.7-.443 1.627-.233 2.07.467l6 9.5.104.196c.296.669.065 1.471-.572 1.873-.7.443-1.627.233-2.07-.467l-6-9.5-.104-.196c-.296-.669-.065-1.471.572-1.873zM32 3c.76 0 1.387.564 1.486 1.296l.014.204V14c0 .828-.672 1.5-1.5 1.5-.76 0-1.387-.564-1.486-1.296L30.5 14V4.5c0-.828.672-1.5 1.5-1.5z"
      opacity=".3"
    />
  </svg>
);

export const FaviconIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none">
      <path
        fill="#526FD3"
        d="M24.277 17.717l1.758 1.83c.263.275.633.432 1.013.432.384 0 .753-.159 1.017-.434l.666-.699v3.118c0 2.601-2.012 4.733-4.565 4.924l-.188.01-.185.004H8.155c-2.665 0-4.837-2.112-4.935-4.753l-.003-.185v-3.117l.666.698c.264.275.633.434 1.015.434.382 0 .752-.157 1.016-.432l1.757-1.83 1.747 1.828c.263.275.633.434 1.015.434.382 0 .751-.157 1.016-.432l1.758-1.83 1.758 1.83c.264.275.633.432 1.014.432.383 0 .753-.159 1.016-.434l1.747-1.828 1.758 1.83c.264.275.633.432 1.014.432.383 0 .752-.159 1.016-.434l1.747-1.828z"
        transform="translate(0 2.5)"
      />
      <path
        fill="#758CDC"
        d="M30.51.278c.544-.61 1.548-.14 1.428.669-.299 2.015-1.375 3.814-2.963 5.038l-.21.156-.032.022-.002 10.34-1.683 1.76-1.832-1.907-.05-.047c-.247-.216-.562-.335-.89-.335-.327 0-.643.12-.889.335l-1.874 1.955-1.833-1.908-.049-.047c-.246-.216-.562-.335-.89-.335-.327 0-.642.12-.889.335l-1.874 1.955-1.832-1.908-.05-.047c-.246-.216-.562-.335-.89-.335-.327 0-.643.12-.889.335l-1.882 1.955-1.823-1.907-.051-.048c-.246-.216-.562-.335-.89-.335-.327 0-.643.12-.889.335L4.9 18.264l-1.683-1.76V6.164l-.243-.179C1.524 4.87.502 3.273.106 1.47l-.055-.272L.01.947C-.11.138.894-.332 1.438.278c1.025 1.15 2.448 1.865 3.985 1.984l.244.014.236.004h20.142c1.729 0 3.337-.736 4.465-2.002z"
        transform="translate(0 2.5)"
      />
    </g>
  </svg>
);

export const CowsquareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="128" height="21">
    <g fill="currentColor">
      <path d="M85.32 6.6a.48.48 0 01.48.48v12.84a.48.48 0 01-.48.48h-.84a.48.48 0 01-.48-.48V16.5a4.5 4.5 0 01-7.195-3.388L76.8 12.9v-1.8A4.5 4.5 0 0184 7.5v-.42a.48.48 0 01.48-.48h.84zm-40.62 0a4.5 4.5 0 014.5 4.5v1.8a4.5 4.5 0 01-9 0v-1.8a4.5 4.5 0 014.5-4.5zm44.82.3a.48.48 0 01.48.48v5.52a2.7 2.7 0 005.397.127l.003-.127V7.38a.48.48 0 01.48-.48h.84a.48.48 0 01.48.48v5.52a4.5 4.5 0 01-8.998.146L88.2 12.9V7.38a.48.48 0 01.48-.48h.84zM32.753 3.6c2.686 0 4.422 1.085 5.207 3.255a.48.48 0 01-.451.643h-1.052a.48.48 0 01-.44-.29c-.564-1.302-1.633-1.905-3.209-1.81-1.943 0-3.335 1.54-3.406 3.465l-.002.135v3l.002.135c.071 1.926 1.463 3.465 3.406 3.465 1.576.095 2.645-.508 3.209-1.81a.476.476 0 01.377-.285l.063-.005h1.052a.479.479 0 01.451.643c-.785 2.17-2.52 3.255-5.207 3.255-2.875.002-5.073-2.33-5.15-5.239l-.003-.159v-3c0-2.982 2.226-5.4 5.153-5.398zM122.7 6.487c2.498 0 4.558 1.699 4.54 4.162.002 1.307-.919 2.18-2.314 2.24l-.133.002-4.775.012.008.073c0 1.42 1.392 2.53 2.674 2.526l3.449.003a.48.48 0 01.48.48v.822a.48.48 0 01-.48.48H122.7c-2.437 0-4.42-2.03-4.498-4.422l-.002-.144V10.94c0-2.46 2.002-4.453 4.5-4.453zm-6.402.14a.48.48 0 01.48.48v.84a.48.48 0 01-.48.48H114.9a2.7 2.7 0 00-2.697 2.572l-.003.127v5.513a.48.48 0 01-.48.48h-.84a.48.48 0 01-.48-.48v-5.513a4.5 4.5 0 014.354-4.497l.146-.003h1.398zm-12.798-.14a4.5 4.5 0 014.498 4.354l.002.146v5.652a.48.48 0 01-.48.48h-.84a.48.48 0 01-.48-.48v-5.652a2.7 2.7 0 00-5.397-.128l-.003.128V12.6a2.7 2.7 0 002.7 2.7c.179 0 .39-.023.633-.068a.48.48 0 01.568.472v.866c0 .24-.177.443-.415.475a5.72 5.72 0 01-.786.055 4.5 4.5 0 01-4.498-4.354L99 12.6v-1.613a4.5 4.5 0 014.5-4.5zM75.129 6.6a.48.48 0 01.48.48v.893a.48.48 0 01-.48.48h-3.557c-1.39 0-2.08.123-2.367.388-.366.338-.505.67-.505 1.172 0 .484.386.868.972.907l.1.004h2.065c1.598 0 2.872 1.185 2.872 2.763 0 1.02-.35 1.856-1.104 2.551-.713.66-1.654.848-3.36.861H66.48a.479.479 0 01-.48-.479v-.893a.48.48 0 01.48-.48h3.557c1.39 0 2.08-.123 2.366-.388.367-.338.506-.67.506-1.172 0-.484-.386-.868-.973-.907l-.1-.004h-2.064c-1.598 0-2.872-1.185-2.872-2.763 0-1.02.35-1.856 1.103-2.551.714-.66 1.655-.848 3.36-.861h3.766zm-23.217 0c.217 0 .407.145.463.355l1.981 7.324 2.158-7.334a.48.48 0 01.46-.345h1.538c.217 0 .407.145.463.355l1.981 7.324 2.158-7.334a.48.48 0 01.46-.345h.884a.48.48 0 01.459.622l-2.845 9.202a.901.901 0 01-.773.617l-.083.003h-.568a.9.9 0 01-.834-.56l-.028-.08-2.064-7.4-2.25 7.42a.901.901 0 01-.773.617l-.083.003h-.568a.9.9 0 01-.834-.56l-.028-.08-2.612-9.193a.48.48 0 01.461-.611h.877zM44.7 8.4a2.7 2.7 0 00-2.7 2.7v1.8a2.7 2.7 0 005.4 0v-1.8a2.7 2.7 0 00-2.7-2.7zm36.6 0a2.7 2.7 0 00-2.695 2.53l-.005.17v1.8a2.7 2.7 0 005.395.17L84 12.9v-1.8a2.7 2.7 0 00-2.7-2.7zm41.4-.132c-1.449 0-2.63 1.129-2.697 2.546l-.003.126v.182l4.791-.012c.43 0 .623-.054.647-.392l.002-.075c.01-1.413-1.12-2.375-2.74-2.375zM17.325 12.644l1.255 1.306a1.007 1.007 0 001.449-.002l.476-.498v2.225a3.526 3.526 0 01-3.259 3.514l-.134.007-.132.003H5.82a3.525 3.525 0 01-3.522-3.392l-.002-.132V13.45l.475.499c.188.196.452.309.724.31.273 0 .537-.113.725-.309l1.255-1.306L6.72 13.95c.188.196.452.309.724.31.273 0 .537-.113.725-.309l1.255-1.306 1.255 1.306a1.006 1.006 0 001.448-.002l1.247-1.304 1.255 1.306a1.003 1.003 0 001.448-.002l1.247-1.304z" />
      <path
        d="M21.773.199c.389-.436 1.106-.1 1.02.477a5.579 5.579 0 01-2.115 3.595l-.15.112-.022.015-.002 7.38-1.2 1.256-1.309-1.361-.035-.034a.963.963 0 00-1.269.001l-1.338 1.394-1.308-1.361-.035-.034a.961.961 0 00-1.27.001l-1.337 1.394-1.308-1.361-.035-.034a.963.963 0 00-1.27.001l-1.343 1.394-1.3-1.36-.037-.035a.963.963 0 00-1.27.001l-1.343 1.394-1.201-1.256v-7.38l-.173-.127A5.573 5.573 0 01.076 1.05L.036.855.008.675C-.079.1.638-.236 1.027.199A4.25 4.25 0 003.87 1.615l.174.01.169.003h14.375c1.233 0 2.38-.525 3.185-1.428z"
        opacity=".8"
      />
    </g>
  </svg>
);

export const UpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 6.543l3.471 3.471.772-.771L8 5 3.757 9.243l.772.771z"
    />
  </svg>
);

export const DownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 9.143L4.529 5.672l-.772.771L8 10.686l4.243-4.243-.772-.771z"
      opacity=".5"
    />
  </svg>
);

export const FoldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M20.25 16.5V18H9.75v-1.5h10.5zm0-5.25v1.5H3.75v-1.5h16.5zm0-5.25v1.5H6.75V6h13.5z"
      opacity=".5"
    />
  </svg>
);

export const UnfoldIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M3.75 16.5V18h10.5v-1.5H3.75zm0-5.25v1.5h16.5v-1.5H3.75zm0-5.25v1.5h13.5V6H3.75z"
      opacity=".5"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.95 19.814l-5.356-5.356a6.134 6.134 0 001.28-3.77 6.15 6.15 0 00-1.812-4.375A6.138 6.138 0 0010.687 4.5a6.15 6.15 0 00-4.374 1.813A6.134 6.134 0 004.5 10.687a6.15 6.15 0 001.813 4.375 6.134 6.134 0 004.374 1.813c1.382 0 2.694-.45 3.769-1.279l5.356 5.354a.17.17 0 00.24 0l.898-.897a.168.168 0 000-.239zm-6.996-5.86a4.59 4.59 0 01-3.267 1.353 4.594 4.594 0 01-3.267-1.353 4.595 4.595 0 01-1.353-3.267c0-1.233.481-2.394 1.353-3.267a4.598 4.598 0 013.267-1.353c1.234 0 2.395.479 3.267 1.353a4.594 4.594 0 011.353 3.267c0 1.234-.48 2.395-1.353 3.267z"
    />
  </svg>
);

export const SignOutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      fill="currentColor"
      d="M13.535 11.353h-1.12a.252.252 0 00-.196.092 5.645 5.645 0 01-2.152 1.6 5.634 5.634 0 01-2.196.442 5.617 5.617 0 01-3.991-1.652 5.6 5.6 0 01-1.21-1.792 5.572 5.572 0 01-.444-2.194 5.615 5.615 0 011.653-3.987 5.652 5.652 0 011.796-1.209 5.617 5.617 0 012.196-.443 5.624 5.624 0 014.348 2.043.256.256 0 00.196.092h1.12c.1 0 .162-.112.106-.196A6.85 6.85 0 007.853 1a6.84 6.84 0 00-6.837 6.919 6.852 6.852 0 006.855 6.778 6.853 6.853 0 005.77-3.148.127.127 0 00-.106-.196zm1.416-3.605l-2.26-1.783a.127.127 0 00-.207.1v1.21H7.482a.128.128 0 00-.127.128v.892c0 .07.057.127.127.127h5.002v1.21c0 .107.124.168.207.1l2.26-1.783a.126.126 0 00-.001-.2z"
      fillRule="evenodd"
    />
  </svg>
);

export const ImportIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.137 1c.133 0 .26.053.354.147l3.362 3.362c.094.094.147.222.147.355V14.5c0 .277-.223.5-.5.5h-10c-.277 0-.5-.223-.5-.5v-3.482h1.125v2.857h8.75V6.156H9.5c-.362 0-.656-.294-.656-.656V2.125H4.125v4.358H3V1.5c0-.246.177-.45.41-.492L3.5 1zm-.23 1.153v2.94h2.94l-2.94-2.94z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 8.145h5.654L5.78 6.27l.707-.707 3.182 3.182-3.182 3.182-.707-.708 1.874-1.873L2 9.345v-1.2z"
    />
  </svg>
);

export const DownloadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.504 1.4v1.2H3c-.193 0-.355.137-.392.32L2.6 3v10c0 .193.137.355.32.392L3 13.4h10c.193 0 .355-.137.392-.32L13.4 13V3c0-.193-.137-.355-.32-.392L13 2.6h-2.457V1.4H13c.835 0 1.52.639 1.593 1.454L14.6 3v10c0 .835-.639 1.52-1.454 1.593L13 14.6H3c-.835 0-1.52-.639-1.593-1.454L1.4 13V3c0-.835.639-1.52 1.454-1.593L3 1.4h2.504zm3.098 0l-.001 7.474L10.477 7l.707.707-3.182 3.182L4.82 7.707 5.527 7l1.874 1.874.001-7.474h1.2z"
    />
  </svg>
);

export const ColumnIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13 1.4c.884 0 1.6.716 1.6 1.6v10c0 .884-.716 1.6-1.6 1.6H3c-.884 0-1.6-.716-1.6-1.6V3c0-.884.716-1.6 1.6-1.6zM5.399 5.1h-2.8L2.6 13c0 .193.137.355.32.392L3 13.4h2.399V5.1zm4 0h-2.8v8.3h2.8V5.1zm4 0h-2.8v8.3H13c.193 0 .355-.137.392-.32L13.4 13l-.001-7.9zm-8-2.5H3c-.22 0-.4.18-.4.4l-.001.9h2.8V2.6zm4 0h-2.8v1.3h2.8V2.6zM13 2.6h-2.401v1.3h2.8L13.4 3c0-.193-.137-.355-.32-.392L13 2.6z"
    />
  </svg>
);

export const ColumnIconFilled = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#526FD3"
        d="M4.75 4.75v9.75H2.583c-.598 0-1.083-.485-1.083-1.083V4.75h3.25zm5.417 0v9.75H5.833V4.75h4.334zm4.333 0v8.667c0 .598-.485 1.083-1.083 1.083H11.25V4.75h3.25zM4.75 1.5v2.167H1.5V2.583c0-.598.485-1.083 1.083-1.083H4.75zm5.417 0v2.167H5.833V1.5h4.334zm3.25 0c.598 0 1.083.485 1.083 1.083v1.084h-3.25V1.5h2.167z"
      />
    </g>
  </svg>
);

export const UploadIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.504 7.3v1.2H3a.4.4 0 00-.392.32L2.6 8.9V13a.4.4 0 00.32.392L3 13.4h10a.4.4 0 00.392-.32L13.4 13V8.9a.4.4 0 00-.32-.392L13 8.5h-2.457V7.3H13c.835 0 1.52.639 1.593 1.454l.007.146V13c0 .835-.639 1.52-1.454 1.593L13 14.6H3c-.835 0-1.52-.639-1.593-1.454L1.4 13V8.9a1.6 1.6 0 011.454-1.594L3 7.3h2.504zm2.498-5.9l3.182 3.182-.707.707-1.874-1.874-.001 7.474h-1.2l.001-7.474L5.527 5.29l-.707-.707L8.002 1.4z"
    />
  </svg>
);

export const CheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        d="M15.251 5.559l-8.214 8.56c-.414.432-1.13.408-1.632-.023l-.143-.142L.864 8.98l1.708-1.453 3.47 3.925 7.368-7.677L15.25 5.56z"
        transform="translate(0 -1)"
      />
    </g>
  </svg>
);
